import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home'
import Devices from '../components/Devices'
import Notifications from '../components/Notifications'
import WeatherTrends from '../components/WeatherTrends'
import Map from '../components/Map'



const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },

    {
    path: '/devices',
    name: 'devices',
    component: Devices
  },


    {
    path: '/notifications',
    name: 'notifications',
    component: Notifications
  },

     {
    path: '/weather-trends',
    name: 'weather-trends',
    component: WeatherTrends
  },


     {
    path: '/map',
    name: 'map',
    component: Map
  },



  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
